const cleaningJobsForEmployeeDict = {
  toConfirmTabLabel: { en: 'To confirm', fr: 'À confirmer' },
  toDoTabLabel: { en: 'To do', fr: 'À faire' },
  inProgressTabLabel: { en: 'In Progress', fr: 'En Cours' },
  DoneTabLabel: { en: 'Done', fr: 'Fait' },
};

export default cleaningJobsForEmployeeDict;
